import React from 'react'
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import PaymentTable from '../../components/datatable/paymentTable'

export default function payment() {
    return (
        <>
            <div className="list">
                <Sidebar />
                <div className="listContainer">
                    <Navbar />
                    <PaymentTable />
                </div>
            </div>
        </>
    )
}
